import {Switch,Route,Redirect} from "react-router-dom"
import CompanyList from "./company-list"
import CompanyAdd from "./company-add"
import CompanyRights from "./company-rights"
const Company =()=>{  
    return(
        <Switch>
            <Route path="/company/list" component={CompanyList}></Route>
            <Route path="/company/add" component={CompanyAdd}></Route>
            <Route path="/company/rights" component={CompanyRights}></Route>

            <Redirect to="/company/list"></Redirect>
        </Switch>
    )
}

export default Company